import { memo } from 'react';
import { IconWrapper } from 'src/modules/common/icons/IconWrapper';

export const ResetIcon = memo(() => (
    <IconWrapper>
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <path
                fill="currentColor"
                // eslint-disable-next-line max-len
                d="M11 19.6c-1.65-.233-3.013-.975-4.088-2.225C5.837 16.125 5.3 14.667 5.3 13c0-.883.175-1.73.525-2.537.35-.809.825-1.53 1.425-2.163l.5.5a5.346 5.346 0 0 0-1.313 1.912A6.072 6.072 0 0 0 6 13c0 1.467.47 2.754 1.412 3.863C8.354 17.97 9.55 18.65 11 18.9v.7Zm2 .05v-.7c1.433-.333 2.625-1.046 3.575-2.137C17.525 15.72 18 14.45 18 13c0-1.667-.583-3.083-1.75-4.25C15.083 7.583 13.667 7 12 7h-.8l1.75 1.75-.5.5-2.6-2.6 2.6-2.6.5.5L11.2 6.3h.8c1.867 0 3.45.65 4.75 1.95 1.3 1.3 1.95 2.883 1.95 4.75 0 1.667-.542 3.117-1.625 4.35-1.083 1.233-2.442 2-4.075 2.3Z"
            />
        </svg>
    </IconWrapper>
));
